/**
 * QUÉ PRODUCTO DE OPUS está abierto, según el HOSTNAME.
 *
 * OPUS ci (planos → HP) convive con OPUS ai dentro de m0 (docs/spec-opus-ci-en-m0.md).
 * La entrada la decide el subdominio:
 *   - Prod: `ai.opus.com.mx` → ai · `ci.opus.com.mx` / `pruebas.ci.opus.com.mx` → ci
 *   - Dev:  `localhost` → ai · `ci.localhost` → ci  (`*.localhost` resuelve a 127.0.0.1 solo)
 *
 * Es la MISMA detección en dev/pruebas/prod: `ci` gana si alguno de los segmentos del
 * host es `ci` (así `pruebas.ci.opus.com.mx` también cae en ci). Sin ramas "si es dev".
 */
export type ProductoOpus = 'ai' | 'ci';

/**
 * Producto a partir de un hostname. Puro (testeable sin `window`): `ci` gana si
 * alguno de los segmentos es `ci`. Todo lo demás (incluido vacío) es ai.
 */
export function productoDeHostname(hostname: string): ProductoOpus {
  return hostname.toLowerCase().split('.').includes('ci') ? 'ci' : 'ai';
}

export function productoActivo(): ProductoOpus {
  return productoDeHostname(typeof window !== 'undefined' ? window.location.hostname : '');
}
